import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LoaderService } from "src/app/loader/loader.service";
import { environment } from "src/environments/environment";
import { Payment } from "../models/payment";
import { ChargesStoreService } from "../services/charges-store.service";
import { ChargesService } from "../services/charges.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-synchronized-charges",
  templateUrl: "./synchronized-charges.component.html",
  styleUrls: ["./synchronized-charges.component.scss"],
})
export class SynchronizedChargesComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  payments: Payment[];

  checkAll: boolean;
  paymentsSelected: Payment[] = [];
  paymentItemsSelected: number = 0;
  motivoEstorno: string = "";
  modalActive: NgbModalRef;

  private unsubscribe$ = new Subject();

  constructor(
    public router: Router,
    public chargesStore: ChargesStoreService,
    private chargesService: ChargesService,
    private loaderService: LoaderService,
    private modalService: NgbModal
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.getSynchronizedPayments();
  }

  getSynchronizedPayments() {
    this.chargesStore.synchronizedPayments$.pipe(takeUntil(this.unsubscribe$)).subscribe(paymentResult => {
      this.pageSize = paymentResult.limit;
      this.page = paymentResult.page;

      this.collectionSize =
        paymentResult.total_docs !== undefined && paymentResult.total_docs !== null
          ? paymentResult.total_docs
          : paymentResult.result.length;

      this.payments = paymentResult.result.map(payment => {
        this.paymentsSelected.find(selected => selected._id === payment._id)
          ? (payment.selected = true)
          : (payment.selected = false);

        return payment;
      });
    });
  }

  getTipoPayment(payment: Payment): string {
    return this.chargesStore.getTipoPayment(payment);
  }

  async onChangePagination() {
    const loader = await this.loaderService.notifica({
      title: "Atualizando paginação...",
      date: moment().toISOString(),
      type: "loading",
    });

    await this.chargesStore.getPayments(this.env.selected.cnpj, this.pageSize, this.page);

    loader.dismiss();
  }

  get hasValidReceiptsSelected(): boolean {
    return this.paymentsSelected.length > 0;
  }

  onChangeSelectionPayment(payment: Payment) {
    if (payment.selected) {
      const selectedIndex = this.paymentsSelected.findIndex(selected => selected._id === payment._id);
      if (selectedIndex === -1) this.paymentsSelected.push(payment);
    } else {
      this.paymentsSelected = this.paymentsSelected.filter(selected => selected._id !== payment._id);
    }

    this.paymentItemsSelected = this.paymentsSelected.length;
  }

  async onToggleSelectionPayments(checkAll: boolean) {
    let page: number = 1;
    let limit: number = 50;
    let paymentResult: any;
    let total_docs: number;
    let payments: Payment[] = [];

    if (checkAll) {
      const loader = await this.loaderService.notifica({
        title: "Carregando seleção...",
        date: moment().toISOString(),
        type: "loading",
      });

      paymentResult = await this.chargesService
        .getPayments(this.env.selected.cnpj, "sincronizado", this.chargesStore.paymentFilter, limit, page)
        .toPromise();

      payments = paymentResult.result;
      total_docs = paymentResult.total_docs;

      while (payments.length < total_docs) {
        page++;
        paymentResult = await this.chargesService
          .getPayments(this.env.selected.cnpj, "sincronizado", this.chargesStore.paymentFilter, limit, page)
          .toPromise();

        payments.push(...paymentResult.result);
      }

      this.paymentsSelected = payments;

      loader.dismiss();
    } else {
      this.paymentsSelected = [];
    }

    this.paymentItemsSelected = this.paymentsSelected.length;

    await this.onChangePagination();
  }

  openModal(modal) {
    if (this.hasValidReceiptsSelected) {
      this.modalActive = this.modalService.open(modal, { size: "lg", centered: true });
    }
  }

  async onConfirmChargeback() {
    const loader = await this.loaderService.notifica({
      title: "Processando estorno...",
      date: moment().toISOString(),
      type: "loading",
    });

    const payload = this.paymentsSelected
      .map(p => ({
        paymentId: p._id,
        contrato: p.contrato,
        baixas: p.baixas && p.baixas.length ? p.baixas.map(b => b.chave) : [],
        cobrador: this.env.user.codigo_externo,
        origem: "cobranca",
        motivo: this.motivoEstorno,
      }))
      .filter(item => item.baixas.length > 0);

    const response = await this.chargesService.requestChargeback(payload).toPromise();

    loader.dismiss();

    // Check if there was an error structure or ok explicitly set to false
    if (!response || response.ok === false || (response.error && response.status !== 200)) {
      await this.loaderService.notifica({
        title: "Erro ao solicitar estorno",
        date: moment().toISOString(),
        type: "error",
      });
    } else {
      await this.loaderService.notifica({
        title: "Estorno solicitado com sucesso!",
        date: moment().toISOString(),
        type: "success",
      });
      this.checkAll = false;
      this.paymentsSelected = [];
      this.paymentItemsSelected = 0;
      this.motivoEstorno = "";
      await this.onChangePagination();
    }

    this.modalActive.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
